/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Ideadox from "../logos/Ideadox.svg";
import { Typography } from "@mui/material";
import Line from "../logos/Line.svg";
import Star from "../logos/Star.svg";
import Concept from "../images/Concept.svg";
import Line1 from "../images/Line1.svg";
import Box from "../logos/Box.svg";
import Line2 from "../logos/Line2.svg";
import Wireframe from "../images/Wireframe.svg";
import Story from "../images/Story.svg";
import MVP from "../images/MVP.svg";
import Architectural from "../images/Architectural Design.svg";
import Developer from "../images/Developer.svg";
import Linkedin from "../logos/Linkedin.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";

export const Aboutus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <div
        style={{
          background: "linear-gradient(to bottom, #F0DFD8, #DBAB97)",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          maxWidth: "100%",
          padding: isMobile ? "1rem" : "0",
          overflowX: "hidden", // Prevent horizontal scrolling
          boxSizing: "border-box", // Include padding and border in element's total width and height
        }}
      >
        <header className="absolute top-0 left-0 right-0 p-6 flex justify-between items-center">
          <div>
            <img
              src={Ideadox}
              alt="Ideadox"
              onClick={() => navigate("/")}
              className="cursor-pointer"
            ></img>
          </div>
          {isMobile ? (
            <div>
              <Button
                className="border border-black mt-2 rounded-full"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                    boxShadow: "none",
                  },
                }}
              >
                <MenuItem
                  onClick={handleMenuClose}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  Blog
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/caseStudy")}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  Case Study
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/aboutus")}
                  style={{
                    color: "#000",
                    fontFamily: "Golos Text",
                  }}
                >
                  About
                </MenuItem>
              </Menu>
              <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
                Get In Touch
              </button>
            </div>
          ) : (
            <nav className="space-x-4 mr-4">
              <button
                className="hover:underline"
                onClick={() => {
                  /* handle click */
                }}
              >
                Blog
              </button>
              <button
                className="hover:underline"
                onClick={() => {
                  navigate("/caseStudy");
                }}
              >
                Case Study
              </button>
              <button
                className="hover:underline"
                onClick={() => navigate("/aboutus")}
              >
                About
              </button>
              <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
                Get In Touch
              </button>
            </nav>
          )}
        </header>

        <div
          className="flex flex-col items-center"
          style={{
            marginTop: isMobile ? "-25%" : "0",
          }}
        >
          <Typography
            style={{
              fontFamily: "Bricolage Grotesque",
              fontWeight: 600,
              fontSize: "36px",
              color: "#78787A",
            }}
          >
            IDEADOX Story
          </Typography>
          <Typography
            style={{
              fontFamily: "Bricolage Grotesque",
              fontWeight: 550,
              fontSize: isMobile ? "35px" : "60px",
              lineHeight: "45px",
              textAlign: "center",
              maxWidth: "600px",
              marginTop: isMobile ? "10%" : "40px",
              background:
                "linear-gradient(76.86deg, #2F2F30 18.47%, #565656 74.52%, #707070 82.94%, #9C9CA9 89.41%, #6F6F6F 119.74%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Our approach is designed to take your startup idea from vision to
            reality in a structured and efficient way.
          </Typography>
          <img
            src={Line}
            alt="line"
            className="absolute top-[65%] transform -translate-y-1/2"
            style={{ zIndex: 5, width: "50%", height: "auto" }}
          />

          <div className="mt-8 flex space-x-4">
            <button className="bg-gray-800 text-white py-2 px-4 rounded-full hover:bg-gray-700">
              Our Process
            </button>
            <button className="bg-white text-gray-800 py-2 px-4 rounded-full border border-white-800 hover:bg-gray-100">
              Get Start
            </button>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#F0DFD8",
          padding: "2rem",
          minHeight: "50vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "0",
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 18,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            How it Works
          </Typography>
        </div>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "35px",
            color: " #2F2F30",
            marginTop: "15px",
          }}
        >
          Sculpting Your Concept into a Stupendous <br /> Product
        </Typography>
        {!isMobile && (
          <>
            <img src={Line1} alt="line1" />
            <img src={Box} alt="Box" className="h-12 w-12" />
            <img src={Line2} alt="Line2" />
            <img src={Box} alt="Box" className="h-12 w-12" />
            <img src={Line2} alt="Line2" />
            <img src={Box} alt="Box" className="h-12 w-12" />
            <img src={Line2} alt="Line2" />
            <img src={Box} alt="Box" className="h-12 w-12" />
            <img src={Line2} alt="Line2" />
            <img src={Box} alt="Box" className="h-12 w-12" />
            <img src={Line2} alt="Line2" />
            <img src={Box} alt="Box" className="h-12 w-12" />
          </>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "1000px",
            paddingLeft: "2rem",
            marginTop: isMobile ? "0" : "-182%",
            marginLeft: "20px",
            flexDirection: isMobile ? "column" : "row", // Stack items vertically on mobile
          }}
        >
          {!isMobile && (
            <img
              src={Concept}
              alt="Concept"
              style={{ maxWidth: "40%", marginRight: "6rem", marginTop: "-9%" }}
            />
          )}
          <div
            style={{
              textAlign: "center",
              marginTop: isMobile ? "3%" : "-2%",
              maxWidth: isMobile ? "45%" : "auto", // Full width on mobile
            }}
          >
            <Typography
              style={{
                fontFamily: "Golos Text",
                fontWeight: 600,
                color: "#2F2F30",
                fontSize: isMobile ? "28px" : "30px",
                textAlign: "center",
                marginLeft: isMobile ? "-8%" : "0",
              }}
            >
              Conceptualization
            </Typography>
            <Typography
              style={{
                fontFamily: "Golos Text",
                fontWeight: 400,
                fontSize: isMobile ? "22px" : "24px",
                color: "#78787A",
                marginTop: "10px",
                gap: isMobile ? "5px" : "10px",
                letterSpacing: "0.5%",
                maxWidth: isMobile ? "85%" : "600px", // Adjust width for mobile
                marginLeft: isMobile ? "2%" : "0",
              }}
            >
              We begin by understanding your idea thoroughly and refining it
              into a concrete project concept. This involves brainstorming
              sessions, market research insights, and identifying the core
              functionalities needed for your product.
            </Typography>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "1000px",
            paddingLeft: "5rem",
            marginTop: "17%",
          }}
        >
          {!isMobile && (
            <img
              src={Wireframe}
              alt="Implementation"
              style={{ maxWidth: "40%", marginRight: "10rem" }}
            />
          )}
          <div
            style={{
              textAlign: "center",
              marginTop: "-2%",
              maxWidth: isMobile ? "45%" : "auto",
            }}
          >
            <Typography
              style={{
                fontFamily: "Golos Text",
                fontWeight: 600,
                color: "#2F2F30",
                fontSize: isMobile ? "28px" : "30px",
                textAlign: "center",
                marginLeft: isMobile ? "-19%" : "0",
              }}
            >
              Wireframes & Designs
            </Typography>
            <Typography
              component="ul"
              style={{
                fontFamily: "Golos Text",
                fontWeight: 400,
                fontSize: isMobile ? "22px" : "24px",
                color: "#78787A",
                marginTop: "10px",
                gap: isMobile ? "5px" : "10px",
                letterSpacing: "0.5%",
                maxWidth: isMobile ? "85%" : "600px", // Adjust width for mobile
                marginLeft: isMobile ? "-2%" : "0",
              }}
            >
              <li>
                Low-Fidelity Screens: At this stage, we create simple,
                blueprint-like screens to map out the user journey and core
                layout without the distractions of design details.
              </li>
              <br />
              <li>
                High-Fidelity Screens: Once the structure is locked in, we
                create visually polished designs that represent exactly how your
                app or platform will look and feel.
              </li>
            </Typography>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60%",
            paddingLeft: "2rem",
            marginTop: isMobile ? "8%" : "1%",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginLeft: "-6rem",
            }}
          >
            {" "}
            <Typography
              style={{
                fontFamily: "Golos Text",
                fontWeight: 600,
                color: "#2F2F30",
                fontSize: isMobile ? "28px" : "30px",
                textAlign: "center",
                marginLeft: isMobile ? "21%" : "0",
              }}
            >
              Story Mapping
            </Typography>
            <Typography
              component="ul"
              style={{
                fontFamily: "Golos Text",
                fontWeight: 400,
                fontSize: "24px",
                color: "#78787A",
                letterSpacing: "0.5%",
                width: isMobile ? "140%" : "477px",
                marginLeft: isMobile ? "-8%" : "0",
                marginTop: isMobile ? "4%" : "0",
              }}
            >
              We strategize the roadmap of your project, breaking it down into
              actionable steps and ensuring alignment with your business goals.
            </Typography>
          </div>
          {!isMobile && (
            <div style={{ marginLeft: "auto", marginTop: "10%" }}>
              {" "}
              <img
                src={Story}
                alt="Story"
                style={{ width: "100%", marginRight: "-5rem" }}
              />
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60%",
            paddingLeft: "2rem",
            marginTop: "15%",
          }}
        >
          <div style={{ textAlign: "center", marginLeft: "-6rem" }}>
            {" "}
            {/* Adjusted marginLeft */}
            <Typography
              style={{
                fontFamily: "Golos Text",
                fontWeight: 600,
                color: "#2F2F30",
                fontSize: isMobile ? "28px" : "30px",
                textAlign: "center",
                marginLeft: isMobile ? "-28%" : "0",
                width: isMobile ? "180%" : "80%",
              }}
            >
              Minimum Vialble Product <br /> (MVP)
            </Typography>
            <Typography
              component="ul"
              style={{
                fontFamily: "Golos Text",
                textAlign: isMobile ? " " : "left",
                fontWeight: 400,
                fontSize: "24px",
                color: "#78787A",
                letterSpacing: "0.5%",
                width: isMobile ? "140%" : "477px",
                marginLeft: isMobile ? "-6%" : "0",
                marginTop: isMobile ? "4%" : "0",
              }}
            >
              Our team develops a streamlined MVP that includes the essential
              features necessary to test your product in the real market. This
              is handled by our expert development team.
            </Typography>
          </div>
          {!isMobile && (
            <div style={{ marginLeft: "auto" }}>
              {" "}
              <img
                src={MVP}
                alt="MVP"
                style={{ width: "100%", marginRight: "-5rem" }}
              />
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "900px",
            paddingLeft: "2rem",
            marginTop: isMobile ? " " : "12%",
          }}
        >
          {!isMobile && (
            <img
              src={Architectural}
              alt="Implementation"
              style={{ maxWidth: "60%", marginRight: "10rem" }}
            />
          )}
          <div style={{ textAlign: "center" }}>
            <Typography
              style={{
                fontFamily: "Golos Text",
                fontWeight: 600,
                color: "#2F2F30",
                fontSize: isMobile ? "28px" : "32px",
                textAlign: "center",
                marginLeft: isMobile ? "-3%" : "0",
              }}
            >
              Architectural Design
            </Typography>
            <Typography
              component="ul"
              style={{
                fontFamily: "Golos Text",
                fontWeight: 400,
                fontSize: "24px",
                color: "#78787A",
                letterSpacing: "0.5%",
                width: isMobile ? "42%" : "477px",
                marginLeft: isMobile ? "28%" : "0",
                marginTop: isMobile ? "4%" : "0",
              }}
            >
              After delivering the MVP, we shift our focus to ensuring your
              product is scalable and future-ready. App Architecture We design
              the structure and framework of your application to optimize
              performance. System Architecture We outline the technical setup,
              including integrations, data flow, and server infrastructure.
            </Typography>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60%",
            paddingLeft: "2rem",
            marginTop: "7%",
          }}
        >
          {!isMobile && (
            <img
              src={Developer}
              alt="Implementation"
              style={{ maxWidth: "50%", marginRight: "12rem" }}
            />
          )}
          <div style={{ textAlign: "center" }}>
            <Typography
              style={{
                fontFamily: "Golos Text",
                fontWeight: 600,
                color: "#2F2F30",
                fontSize: isMobile ? "28px" : "32px",
                textAlign: "center",
                marginLeft: isMobile ? "-95%" : "",
                width: isMobile ? "280%" : "",
              }}
            >
              Support for Developers
            </Typography>
            <Typography
              component="ul"
              style={{
                fontFamily: "Golos Text",
                fontWeight: 400,
                fontSize: "24px",
                color: "#78787A",
                letterSpacing: "0.5%",
                width: isMobile ? "230%" : "547px",
                marginTop: isMobile ? "5%" : "5px",
                marginLeft: isMobile ? "-72%" : "0",
              }}
            >
              Even after delivering the architecture, we stay with you
              throughout the development process. Our team supports your
              developers by resolving technical challenges, ensuring the
              architecture is correctly implemented, and preparing the product
              for launch. With this end-to-end support, our goal is to make your
              vision a reality while ensuring a smooth and collaborative
              experience at every step.
            </Typography>
          </div>
        </div>
        <footer
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            marginTop: isMobile ? 0 : 5,
            padding: isMobile ? "1rem" : "0.5rem",
          }}
        >
          <div
            className="flex flex-col md:flex-row items-center"
            style={{ gap: isMobile ? "1rem" : "2rem" }}
          >
            <img
              src={Ideadox}
              alt="Ideadox"
              className="mb-4 md:mb-0"
              style={{ width: isMobile ? "80px" : "auto" }}
            />
            <div
              className="flex justify-center"
              style={{
                gap: isMobile ? "1rem" : "2rem",
                marginLeft: isMobile ? "0" : "24rem",
              }}
            >
              <button
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 500,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                Blog
              </button>
              <button
                onClick={() => {
                  navigate("/caseStudy");
                }}
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 500,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                Case Study
              </button>
              <button
                onClick={() => {
                  navigate("/aboutus");
                }}
                className="hover:underline"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 500,
                  fontSize: isMobile ? "16px" : "20px",
                }}
              >
                About
              </button>
            </div>
          </div>
          <div
            className="flex items-center justify-center"
            style={{
              gap: isMobile ? "1rem" : "2rem",
              marginTop: isMobile ? "1rem" : "0",
            }}
          >
            <button
              className="text-black"
              style={{
                fontFamily: "Golos Text",
                fontSize: isMobile ? "15px" : "17px",
              }}
            >
              Contact us
            </button>
            <img
              src={Linkedin}
              alt="LinkedIn"
              className="w-10 h-10"
              style={{ width: isMobile ? "30px" : "40px" }}
            />
          </div>
        </footer>
      </div>
    </>
  );
};

export default Aboutus;
